import { createContext, useContext } from 'react';

type FieldName = string | number | (string | number)[];

export const AgentReviewEditsContext = createContext<((name: FieldName) => void) | undefined>(
  undefined
);

export const useAgentReviewEdits = () => useContext(AgentReviewEditsContext);

export const agentEditedFieldPath = (name: FieldName): string | undefined => {
  const parts = Array.isArray(name) ? name : [name];
  if (parts.length < 2) return undefined;
  return parts.reduce<string>((path, part) =>
    typeof part === 'number' || /^\d+$/.test(part)
      ? `${path}[${part}]` : `${path ? `${path}.` : ''}${part}`, '');
};
